(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VueAwesomePicker", [], factory);
	else if(typeof exports === 'object')
		exports["VueAwesomePicker"] = factory();
	else
		root["VueAwesomePicker"] = factory();
})(this, () => {
return 